import axios from 'axios';
import { globalSettings, isUndNullEmp, responseGet } from '../../helpers/settings';

let result = {};
let dataObj = {};
let headerObj = {};

const { app, messages, } = globalSettings;
const { backend, } = app;

//#region methods
export const userApartmentsGetAsync = async ({
    buildingId = '',
    auth = {},
    userRole = '',
    method = '',
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'userApartmentsGetAsync';
    let response = responseGet();
    try {
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            },
        };

        dataObj = {
            conditionals: [],
            ordersBy: [],
            buildingId: buildingId,
            method: method,
            // Stay here
            // Do for all users
            userId: userRole === globalSettings?.roles?.master ? '' : auth?.user?.uid,
            withDetails: true,
            languageId: languageId,
            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentUsers}/`,
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headerObj,
        );

        response = result?.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const buildingsByUserGetAsync = async ({
    userRole = {},
    auth = {},
    urlGoTo = '',
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'buildingsByUserGetAsync';
    let response = responseGet();
    try {
        //#region variables
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Sub method: ${subMethod}`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region Chek local role
        if (isUndNullEmp({ data: userRole, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText = messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageId];
            responseIsWarning.urlGoTo = backend?.urlHome;
            return responseIsWarning
        }
        //#endregion Chek local role

        //#region data get
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            }
        };

        dataObj = {
            method: backend?.methods?.checkUserIsCondominiumBoard,
            languageId: languageId,
            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentUsers}/${backend?.methods?.buildingsByUser}`
        };

        result = await axios?.post(
            dataObj?.url,
            dataObj,
            headerObj,
        );

        response = result.data;

        if (!response?.isSuccess || response?.isWarning) {
            return response
        }
        //#endregion data get
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}
//#endregion methods